import { Codicon } from '../../../../base/common/codicons.js';
import { localizeWithPath } from '../../../../nls.js';
import { registerIcon } from '../../../../platform/theme/common/iconRegistry.js';
const _moduleId = "vs/workbench/contrib/extensions/browser/extensionsIcons";
const extensionsViewIcon = registerIcon('extensions-view-icon', Codicon.extensions, ( localizeWithPath(_moduleId, 0, 'View icon of the extensions view.')));
const manageExtensionIcon = registerIcon('extensions-manage', Codicon.gear, ( localizeWithPath(_moduleId, 1, 'Icon for the \'Manage\' action in the extensions view.')));
const clearSearchResultsIcon = registerIcon('extensions-clear-search-results', Codicon.clearAll, ( localizeWithPath(
 _moduleId,
 2,
 'Icon for the \'Clear Search Result\' action in the extensions view.'
)));
const refreshIcon = registerIcon('extensions-refresh', Codicon.refresh, ( localizeWithPath(_moduleId, 3, 'Icon for the \'Refresh\' action in the extensions view.')));
const filterIcon = registerIcon('extensions-filter', Codicon.filter, ( localizeWithPath(_moduleId, 4, 'Icon for the \'Filter\' action in the extensions view.')));
const installLocalInRemoteIcon = registerIcon('extensions-install-local-in-remote', Codicon.cloudDownload, ( localizeWithPath(
 _moduleId,
 5,
 'Icon for the \'Install Local Extension in Remote\' action in the extensions view.'
)));
const installWorkspaceRecommendedIcon = registerIcon('extensions-install-workspace-recommended', Codicon.cloudDownload, ( localizeWithPath(
 _moduleId,
 6,
 'Icon for the \'Install Workspace Recommended Extensions\' action in the extensions view.'
)));
const configureRecommendedIcon = registerIcon('extensions-configure-recommended', Codicon.pencil, ( localizeWithPath(
 _moduleId,
 7,
 'Icon for the \'Configure Recommended Extensions\' action in the extensions view.'
)));
const syncEnabledIcon = registerIcon('extensions-sync-enabled', Codicon.sync, ( localizeWithPath(_moduleId, 8, 'Icon to indicate that an extension is synced.')));
const syncIgnoredIcon = registerIcon('extensions-sync-ignored', Codicon.syncIgnored, ( localizeWithPath(
 _moduleId,
 9,
 'Icon to indicate that an extension is ignored when syncing.'
)));
const remoteIcon = registerIcon('extensions-remote', Codicon.remote, ( localizeWithPath(
 _moduleId,
 10,
 'Icon to indicate that an extension is remote in the extensions view and editor.'
)));
const installCountIcon = registerIcon('extensions-install-count', Codicon.cloudDownload, ( localizeWithPath(
 _moduleId,
 11,
 'Icon shown along with the install count in the extensions view and editor.'
)));
const ratingIcon = registerIcon('extensions-rating', Codicon.star, ( localizeWithPath(
 _moduleId,
 12,
 'Icon shown along with the rating in the extensions view and editor.'
)));
const verifiedPublisherIcon = registerIcon('extensions-verified-publisher', Codicon.verifiedFilled, ( localizeWithPath(
 _moduleId,
 13,
 'Icon used for the verified extension publisher in the extensions view and editor.'
)));
const preReleaseIcon = registerIcon('extensions-pre-release', Codicon.versions, ( localizeWithPath(
 _moduleId,
 14,
 'Icon shown for extensions having pre-release versions in extensions view and editor.'
)));
const sponsorIcon = registerIcon('extensions-sponsor', Codicon.heartFilled, ( localizeWithPath(
 _moduleId,
 15,
 'Icon used for sponsoring extensions in the extensions view and editor.'
)));
const starFullIcon = registerIcon('extensions-star-full', Codicon.starFull, ( localizeWithPath(
 _moduleId,
 16,
 'Full star icon used for the rating in the extensions editor.'
)));
const starHalfIcon = registerIcon('extensions-star-half', Codicon.starHalf, ( localizeWithPath(
 _moduleId,
 17,
 'Half star icon used for the rating in the extensions editor.'
)));
const starEmptyIcon = registerIcon('extensions-star-empty', Codicon.starEmpty, ( localizeWithPath(
 _moduleId,
 18,
 'Empty star icon used for the rating in the extensions editor.'
)));
const errorIcon = registerIcon('extensions-error-message', Codicon.error, ( localizeWithPath(_moduleId, 19, 'Icon shown with a error message in the extensions editor.')));
const warningIcon = registerIcon('extensions-warning-message', Codicon.warning, ( localizeWithPath(
 _moduleId,
 20,
 'Icon shown with a warning message in the extensions editor.'
)));
const infoIcon = registerIcon('extensions-info-message', Codicon.info, ( localizeWithPath(_moduleId, 21, 'Icon shown with an info message in the extensions editor.')));
const trustIcon = registerIcon('extension-workspace-trust', Codicon.shield, ( localizeWithPath(
 _moduleId,
 22,
 'Icon shown with a workspace trust message in the extension editor.'
)));
const activationTimeIcon = registerIcon('extension-activation-time', Codicon.history, ( localizeWithPath(
 _moduleId,
 23,
 'Icon shown with a activation time message in the extension editor.'
)));
export { activationTimeIcon, clearSearchResultsIcon, configureRecommendedIcon, errorIcon, extensionsViewIcon, filterIcon, infoIcon, installCountIcon, installLocalInRemoteIcon, installWorkspaceRecommendedIcon, manageExtensionIcon, preReleaseIcon, ratingIcon, refreshIcon, remoteIcon, sponsorIcon, starEmptyIcon, starFullIcon, starHalfIcon, syncEnabledIcon, syncIgnoredIcon, trustIcon, verifiedPublisherIcon, warningIcon };
